import React from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { Home } from 'lucide-react';

const Header = ({ title, showProgress = false, currentStep = 1 }) => {
  const navigate = useNavigate();

  return (
    <header className="header">
      <div className="header-content">
        <div className="header-left">
          <button onClick={() => navigate('/')} className="home-button">
            <Home size={20} />
          </button>
          {title && <h1 className="header-title">{title}</h1>}
        </div>
        {showProgress && (
          <div className="progress-bar">
            {[1, 2, 3, 4, 5, 6].map((step) => (
              <React.Fragment key={step}>
                <div className={`step-circle ${step < currentStep ? 'completed' : step === currentStep ? 'active' : 'pending'}`}>
                  {step < currentStep ? '✓' : step}
                </div>
                {step < 6 && <div className={`step-line ${step < currentStep ? 'completed' : ''}`} />}
              </React.Fragment>
            ))}
          </div>
        )}
        <nav className="nav">
          <Link to="/">Dashboard</Link>
          <Link to="/protocol">Protocols</Link>
          <Link to="/analysis">Analysis</Link>
          <div className="user-avatar">JS</div>
        </nav>
      </div>
    </header>
  );
};

export default Header;

